import { SvgIcon, SvgIconProps} from '@mui/material';
import './ccf-sorting-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfSortingIconProps extends SvgIconProps {}

/**
 * component used to display sorting icon
 * @param props - CcfSortingIcon
 * @example - <CcfSortingIcon />
 * @returns SVG of sorting icon
 */
export function CcfSortingIcon(props: CcfSortingIconProps) {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <circle
        cx="10"
        cy="10"
        r="9"
        fill="#F2F2F2"
        stroke="#3F5C69"
        strokeWidth="2"
      />
      <path
        d="M5.1427 6.85718H15.4284M6.85699 10.2857H13.7141M8.57127 13.7143H11.9998"
        stroke="#3F5C69"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}

export default CcfSortingIcon;
